module.exports = __webpack_public_path__ + "static/img/低代码_bj@2x.b5602ed3.png";